import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {LibraryDialogController} from '../LibraryDialog.controller';
import classNames from 'classnames';

@observer
export class LibraryDialogContent extends TechseeBaseComponent<{ctrl: LibraryDialogController}> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        // Force access to observables to create MobX dependencies
        const pathKey = ctrl.libDirectories.join('/');
        const itemsList = ctrl.items.slice(); // Force observable to array

        return (
            <div className='text-center' key={pathKey}>
                {itemsList.map((item, index) => {
                    // Access item.state.selected to create MobX dependency
                    const isSelected = item.state?.selected;

                    return (
                        <div
                            key={`${item.data.title}-${item.data.type}-${index}`}
                            onClick={(e) => {
                                ctrl.clickItem(item);
                            }}
                            className={classNames('col-xs-6 col-sm-3', {
                                selected: isSelected
                            })}>
                            <div className='thumbnail'>
                                <img
                                    src={
                                        item.data.type === 'img'
                                            ? item.data.url
                                            : ctrl.requireImage(item.data.type === 'dir' ? 'directory.png' : 'file.png')
                                    }
                                    className='img-responsive ts-img-expand'
                                    alt={item.data.title}
                                />
                            </div>
                            <div className='thumbnail-name'>
                                <small>{item.data.title}</small>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
